exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.label-input {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 0 3px;\n  margin-bottom: 0;\n}\n\n.text-require {\n  color: #f52606;\n}\n\n.inputs input {\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 0;\n  border-bottom: 2px solid #061178;\n  font-size: 20px;\n}\n\ninput[type=number]::-webkit-inner-spin-button,\ninput[type=number]::-webkit-outer-spin-button {\n  -moz-appearance: none;\n  appearance: none;\n  margin: 0\n}\n\n.otp-value:focus {\n  box-shadow: none;\n  border: none;\n}\n\n.resend-otp {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: end;\n      align-items: flex-end;\n}\n\n.resend-otp .text {\n  margin-bottom: 0;\n  margin-left: 4px;\n  cursor: pointer;\n  color: #0a6aa1;\n  font-size: 16px;\n}\n\n.box {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  margin-top: 40px;\n}\n\n.btn-confirm {\n  width: 140px;\n}\n\n\n\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/auth/register-icheck/register-icheck.component.css
// module id = ../../../../../src/app/pages/admin/auth/register-icheck/register-icheck.component.css
// module chunks = 3